module.exports = __webpack_public_path__ + "img/cart-buy.e51cb13b.png";